import { SaleDocumentStatus } from "../../sale-documents/sale-document-statuses/sale-document-status.model";

export class SaleInvoiceHeaderStatus extends SaleDocumentStatus {
}
